export default __webpack_public_path__ + "static/meditate-369221d0b59dc47c1f4f92ba94f644c2.png";